import { Observable, Observer } from 'rxjs';

export const exifStartUint16 = 0xFFE1;
export const rotationUint16 = 0x0112;

export interface ICanvasPosition {
  width: number;
  height: number;
  x: number;
  y: number;
}

export function getPosition(img: HTMLImageElement, degree): ICanvasPosition {
  const [width, height, x, y] = [img.width, img.height, 0, 0];
  const position = {
    0: {width, height, x, y},
    90: {width: height, height: width, x, y: height * (-1)},
    180: {width, height, x: width * (-1), y: height * (-1)},
    270: {width: height, height: width, x: width * (-1), y},
  };

  return position[degree] || position[0];
}

export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;

  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return window.btoa(binary);
}

export function convertToBase64(loadImage: ArrayBuffer, type: string): Observable<string> {
  return Observable.create((observer: Observer<string>) => {
    const base64img = `data:${type};base64,${arrayBufferToBase64(loadImage)}`;
    const canvas = document.createElement('canvas');

    if (canvas.getContext) {
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.src = base64img;
      img.onload = () => {
        const position = getPosition(img, 0);
        canvas.setAttribute('width', `${position.width}`);
        canvas.setAttribute('height', `${position.height}`);
        ctx.drawImage(img, position.x, position.y);
        observer.next(canvas.toDataURL(type));
        observer.complete();
      };
    } else {
      observer.next(base64img);
      observer.complete();
    }
  });
}
